import React, { useEffect, useState } from 'react';
import style from './UserDashboardPage.module.scss';
import AccountBalancePanel from './components/AccountBalancePanel';
import { useNavigate } from 'react-router-dom';
import { useGetAccountInfo } from '@multiversx/sdk-dapp/hooks';
import StakingPoolsContainer from './components/StakingPoolsContainer';
import useCurrentEpoch from 'src/hooks/useCurrentEpoch';
import useTokenBalance from 'src/hooks/useTokenBalance';
import { aprGuaranteedDisclaimerVisibility, tokenIdentifier } from 'src/config';
import AprGuaranteedDisclaimer from './components/components/AprGuaranteedDisclaimer';

function UserDashboard() {
    const navigate = useNavigate();
    const { account } = useGetAccountInfo();
    const { currentEpoch } = useCurrentEpoch();
    const { tokenBalance } = useTokenBalance(account.address, tokenIdentifier);
    const [totalStakeAmounts, setTotalStakeAmounts] = useState({});
    const isConnected = account && account.address;

    const updateTotalStakeAmount = (poolDiscriminant, amount) => {
        setTotalStakeAmounts((prevAmounts) => {
            if (prevAmounts[poolDiscriminant] !== amount) {
                return {
                    ...prevAmounts,
                    [poolDiscriminant]: amount,
                };
            }
            return prevAmounts;
        });
    };

    useEffect(() => {
        return () => {
            setTotalStakeAmounts({});
        };
    }, []);

    useEffect(() => {
        if (!isConnected) {
            navigate('/connect-wallet');
        }
    }, [isConnected, navigate]);

    return (
        <div className={style.userDashboard}>
            <div className={style.migrationBanner}>
                <p>
                    Staking.ta-da.io is a platform that was created to connect stakers to the Ta-da mobile application and provide a wide range of features related to the gamification system. Since the mobile application has been replaced by <a href="https://ta-da.io/platform" target="_blank" rel="noreferrer">ta-da.io/platform</a>, the staking site will gradually be replaced by several professional staking platforms, starting with <a href="https://xexchange.com/staking/TADA-5c032c" target="_blank" rel="noreferrer">xExchange</a>. However, this platform will remain online to allow holders to claim their rewards.
                </p>
            </div>
            <AccountBalancePanel
                account={account}
                totalStakeAmounts={totalStakeAmounts}
                tokenBalance={tokenBalance || 0}
            />
            {aprGuaranteedDisclaimerVisibility &&  <AprGuaranteedDisclaimer />}
            <StakingPoolsContainer
                currentEpoch={currentEpoch}
                account={account}
                tokenBalance={tokenBalance}
                updateTotalStakeAmount={updateTotalStakeAmount}
            />
        </div>
    );
}

export default UserDashboard;
